module.exports = __webpack_public_path__ + "assets/img/mid-autumn-qr-code.35bc1eb4.jpg";